import { render, staticRenderFns } from "./sidebar_lesson.vue?vue&type=template&id=5978103e&scoped=true&"
import script from "./sidebar_lesson.vue?vue&type=script&lang=js&"
export * from "./sidebar_lesson.vue?vue&type=script&lang=js&"
import style0 from "./sidebar_lesson.vue?vue&type=style&index=0&id=5978103e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5978103e",
  null
  
)

export default component.exports